// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","toggle":"toggle-NuCS_","toggle_active":"toggle_active-3KPCr","switch__label":"switch__label-2wTzZ"};